const sizeSort = (a, b) => {
  a = String(a?.size || "");
  b = String(b?.size || "");

  // american sizes
  const order = ["xxs", "xs", "s", "m", "l", "xl", "2xl", "xxl"];
  if (order.includes(a.toLowerCase()) && order.includes(b.toLowerCase())) {
    const aIndex = order.indexOf(a.toLowerCase());
    const bIndex = order.indexOf(b.toLowerCase());
    return aIndex - bIndex;
  }
  // shoe sizes
  if (a.includes("½") || b.includes("½")) {
    a = a.replace("½", ".5");
    b = b.replace("½", ".5");
  }

  // baby and kid sizes
  const babyKidRegex = /^([0-9]+\/)?([0-9]+[aAmM])$/;

  if (babyKidRegex.test(a) && babyKidRegex.test(b)) {
    const babyRegex = /([0-9]+\/)?([0-9]+[mM])/;
    const kidRegex = /[0-9]+[aA]/;
    // sort baby sizes before kid sizes
    if (babyRegex.test(a) && kidRegex.test(b)) return -1;
    if (kidRegex.test(a) && babyRegex.test(b)) return 1;
    if (babyRegex.test(a) && babyRegex.test(b)) {
      const aValues = a.replace(/[mM]/, "").split("/");
      const bValues = b.replace(/[mM]/, "").split("/");
      a = Number(aValues[0]);
      b = Number(bValues[0]);
      //define if size is a range (e.g. "3/6m"). If so, take the average
      if (aValues.length === 2) {
        a = (Number(aValues[1]) + Number(aValues[0])) / 2;
      }
      if (bValues.length === 2) {
        b = (Number(bValues[1]) + Number(bValues[0])) / 2;
      }
    }
    if (kidRegex.test(a) && kidRegex.test(b)) {
      a.replace(/[aA]/, "");
      b.replace(/[aA]/, "");
    }
  }

  const numA = parseFloat(a);
  const numB = parseFloat(b);

  if (isNaN(numA) && isNaN(numB)) return 0;
  if (isNaN(numA)) return 1;
  if (isNaN(numB)) return -1;
  return numA - numB;
};

export default sizeSort;
